import { lazy } from "react";

import { BlockKind, Block as BlockType } from "../types";

import styles from "../styles/Block.module.less";

const SingleVisualBlock = lazy(() => import("./primary/SingleVisualBlock"));
const HeadingBlock = lazy(() => import("./primary/HeadingBlock"));
const TextBannerBlock = lazy(() => import("./primary/TextBannerBlock"));
const HeroVisualBlock = lazy(() => import("./primary/HeroVisualBlock"));
const MyZoetisRewardsBlock = lazy(() => import("./primary/MyZoetisRewardsBlock"));
const ImageBlock = lazy(() => import("./secondary/ImageBlock"));
const VideoBlock = lazy(() => import("./secondary/VideoBlock"));
const FactsBlock = lazy(() => import("./secondary/FactsBlock"));
const StatsBlock = lazy(() => import("./secondary/StatsBlock"));
const ActionContentBlock = lazy(() => import("./secondary/ActionContentBlock"));

const exhaustiveCheck = (block: never) => {
  console.warn(`No block defined for ${block}`);
  return null;
};

type BlockNodeProps = {
  block: BlockType;
};

const Block = ({ block }: BlockNodeProps) => {
  switch (block.kind) {
    case BlockKind.Image:
      return <ImageBlock block={block} className={styles.Image} />;
    case BlockKind.Video:
      return <VideoBlock block={block} className={styles.Image} />;
    case BlockKind.SingleVisual:
      return <SingleVisualBlock block={block} className={styles.SingleVisual} />;
    case BlockKind.Facts:
      return <FactsBlock block={block} className={styles.Facts} />;
    case BlockKind.ActionContent:
      return <ActionContentBlock block={block} className={styles.ActionContent} />;
    case BlockKind.Heading:
      return <HeadingBlock block={block} className={styles.Heading} />;
    case BlockKind.TextBanner:
      return <TextBannerBlock block={block} className={styles.TextBanner} />;
    case BlockKind.HeroVisual:
      return <HeroVisualBlock block={block} className={styles.HeroVisual} />;
    case BlockKind.Stats:
      return <StatsBlock block={block} className={styles.Stats} />;
    case BlockKind.MyZoetisRewards:
      return <MyZoetisRewardsBlock block={block} className={styles.MyZoetisRewards} />;
    default:
      return exhaustiveCheck(block);
  }
};

export default Block;
